import {Fancybox} from "@fancyapps/ui";

export default function initializeFancybox() {
  Fancybox.bind("[data-fancybox]", {
    Toolbar: {
      display: {
        left: ["infobar"],
        middle: [],
        right: ["slideshow", "thumbs", "close"],
      },
    },
  });
}
